import { modules } from '../../components/CrossModuleLink';
import { modulesMetaData } from '../../components/CrossModuleLink/modules';
import { getPageUrl } from '../../components/CrossModuleLink/utils';
import stringUtils from '../../utils/string';
import { PAGE_CONTEXT_PERSIST_KEY } from './const';
import { decodeListDataFilter } from '../list';

export const setDocumentTitle = (title) => {
	if (stringUtils.isNullOrEmpty(title)) {
		return;
	}

	document.title = title;
	const pageMetaTitleId = document.getElementById('page-meta-title-id');

	if (pageMetaTitleId !== null) {
		pageMetaTitleId.setAttribute('content', title);
	}
};

export function getComputedPersistKey(pageTypeId) {
	return `${PAGE_CONTEXT_PERSIST_KEY}_${pageTypeId}`;
}

export const getPageListUrl = (search: string): string => {
	const urlSearchParams = new URLSearchParams(search);

	return getPageUrl({
		module: modules.PAGE,
		route: modulesMetaData[modules.PAGE].list,
		params: decodeListDataFilter(urlSearchParams.get('listData')),
	});
};

export const getPageDetailUrl = (path: string, labelId: number, listData?: string) => {
	return getPageUrl({
		module: modules.PAGE,
		route: modulesMetaData[modules.PAGE].detail,
		params: {
			path,
			labelId,
			listData,
		},
	});
};
